<div class="toast-msg-conatiner" *ngIf="showToast">
    <div class="toast-msg" [style.backgroundColor]="isSuccess ? '#73d76a' : '#f54b4b'">
        {{notificationMsg}}
    </div>
</div>

<div *ngIf="isLoading" class="loading">
    <div class="spinner-border m-auto" role="status">
        <span class="sr-only ">Loading...</span>
    </div>
</div>

<div class="p-3 " style="background-color: white; min-height: 100%;">
    <div *ngIf="!isLoading" class="d-flex flex-column py-2">
        <div class="d-flex align-items-center justify-content-between">
            <div style="color: #757575; font-size: 18px; font-weight: 600;">Profile Info</div>
            <div *ngIf="isAdminUser" class="d-flex align-items-center justify-content-end">
                <button class="ml-1" [ngClass]="isUserInfoEdit ? 'cancel-btn': 'edit-btn' "
                    (click)="editbtnClicked()">
                    {{ isUserInfoEdit ? 'Cancel' : 'Edit' }}
                </button>
                <button (click)="submitUserInfoEdit()" class="edit-btn ml-1" *ngIf="isUserInfoEdit">Save</button>
            </div>
        </div>

        <ng-container >
            <form *ngIf="!isUserInfoEdit" [formGroup]="UserInfo">
                <div class="d-flex flex-column mt-2" style="gap: 0.5rem;">
                    <div class="d-flex flex-column" style="font-size: 14px;">
                        <div style="color: #673AB7; font-size: 13px;">First Name :</div>
                        <input type="text" class="form-control input-field" formControlName="FirstName" />
                        <small class="text-danger mb-2"
                            *ngIf="UserInfo.get('FirstName')?.touched && UserInfo.get('FirstName')?.invalid">
                            First name is required.
                        </small>
                    </div>
    
                    <div class="d-flex flex-column" style="font-size: 14px;">
                        <div style="color: #673AB7; font-size: 13px;">Last Name :</div>
                        <input type="text" class="form-control input-field" formControlName="LastName" />
                    </div>

                    <div class="d-flex flex-column" style="font-size: 15px;">
                        <div style="color: #673AB7; font-size: 14px;">Status :</div>
                        <div>
                            <span class="chip-base" [ngClass]="profileDetails?.IsActive ? 'Delivered' : 'Rejected'">
                                {{profileDetails?.IsActive ?
                                'Active' : 'Inactive'}}
                            </span>
                        </div>
                    </div>
    
                    <div class="d-flex flex-column" style="font-size: 14px;">
                        <div style="color: #673AB7; font-size: 13px;">E-mail :</div>
                        <input type="text" class="form-control input-field" formControlName="Email" />
                    </div>
                    <div class="d-flex flex-column" style="font-size: 14px;">
                        <div style="color: #673AB7; font-size: 13px;">Mobile No :</div>
                        <input type="text" class="form-control input-field" formControlName="MobileNo" />
                    </div>
    
                    <div class="d-flex flex-column" style="font-size: 14px;">
                        <div style="color: #673AB7; font-size: 13px;">District :</div>
                        <input type="text" class="form-control input-field" formControlName="District" />
                    </div>
    
                    <div class="d-flex flex-column" style="font-size: 14px;">
                        <div style="color: #673AB7; font-size: 13px;">State :</div>
                        <input type="text" class="form-control input-field" formControlName="State" />
                    </div>
    
                    <div class="d-flex flex-column" style="font-size: 14px;">
                        <div style="color: #673AB7; font-size: 13px;">Country :</div>
                        <input type="text" class="form-control input-field" formControlName="Country" />
                    </div>
    
                    <div class="d-flex flex-column" style="font-size: 14px;">
                        <div style="color: #673AB7; font-size: 13px;">Landmark :</div>
                        <input type="text" class="form-control input-field" formControlName="landmark" />
                    </div>
    
                    <div class="d-flex flex-column" style="font-size: 14px;">
                        <div style="color: #673AB7; font-size: 13px;">Pincode :</div>
                        <input type="text" class="form-control input-field" formControlName="Pincode" />
                    </div>
                </div>
            </form>
        </ng-container>



        <ng-container >
            <form *ngIf="isUserInfoEdit" [formGroup]="UserInfo">
                <div class="d-flex flex-column mt-2" style="gap: 0.5rem;">
                    <div class="d-flex flex-column" style="font-size: 14px;">
                        <div style="color: #673AB7; font-size: 13px;">First Name :</div>
                        <input type="text" class="form-control input-field" formControlName="FirstName" />
                        <small class="text-danger mb-2"
                            *ngIf="UserInfo.get('FirstName')?.touched && UserInfo.get('FirstName')?.invalid">
                            First name is required.
                        </small>
                    </div>
    
                    <div class="d-flex flex-column" style="font-size: 14px;">
                        <div style="color: #673AB7; font-size: 13px;">Last Name :</div>
                        <input type="text" class="form-control input-field" formControlName="LastName" />
                    </div>
    
                    <div class="d-flex flex-column" style="font-size: 14px;">
                        <div style="color: #673AB7; font-size: 13px;">E-mail :</div>
                        <input type="text" class="form-control input-field" formControlName="Email" />
                    </div>
    
                    <div class="d-flex flex-column" style="font-size: 14px;">
                        <div style="color: #673AB7; font-size: 13px;">District :</div>
                        <input type="text" class="form-control input-field" formControlName="District" />
                    </div>
    
                    <div class="d-flex flex-column" style="font-size: 14px;">
                        <div style="color: #673AB7; font-size: 13px;">State :</div>
                        <input type="text" class="form-control input-field" formControlName="State" />
                    </div>
    
                    <div class="d-flex flex-column" style="font-size: 14px;">
                        <div style="color: #673AB7; font-size: 13px;">Country :</div>
                        <input type="text" class="form-control input-field" formControlName="Country" />
                    </div>
    
                    <div class="d-flex flex-column" style="font-size: 14px;">
                        <div style="color: #673AB7; font-size: 13px;">Landmark :</div>
                        <input type="text" class="form-control input-field" formControlName="landmark" />
                    </div>
    
                    <div class="d-flex flex-column" style="font-size: 14px;">
                        <div style="color: #673AB7; font-size: 13px;">Pincode :</div>
                        <input type="text" class="form-control input-field" formControlName="Pincode" />
                    </div>
                </div>
            </form>
        </ng-container>
    </div>
</div>